import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { MatCommonModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule} from '@angular/material/menu';
import { ChartsModule } from 'ng2-charts';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatDialogModule} from '@angular/material/dialog';
import { PdfViewerModule } from 'ng2-pdf-viewer';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatChipsModule,
    MatCommonModule,
    MatInputModule ,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    ChartsModule,
    FlexLayoutModule,
    NgxExtendedPdfViewerModule,
    MatDialogModule,
    PdfViewerModule
  ],
  exports:[
    CommonModule,
    MatChipsModule,
    MatCommonModule,
    MatInputModule ,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    ChartsModule,
    FlexLayoutModule,
    NgxExtendedPdfViewerModule,
    MatDialogModule,
    PdfViewerModule
  ]
})
export class ExternalModule { }
